import React from 'react';
import clsx from 'clsx';
import { createStyles } from './styles';

interface SubtitleWithLinesProps {
  text: string | JSX.Element;
  className?: string;
}

const SubtitleWithLines = ({ text, className }: SubtitleWithLinesProps): JSX.Element => {
  const classes = createStyles();
  return (
    <h3 className={clsx(classes.subtitleWithLines, className)}>
      {/* Span wrapper helps to show lines from both sides of subtitle */}
      <span className={classes.subtitleText}>{text}</span>
    </h3>
  );
};

export default SubtitleWithLines;
